var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewSubmit, Vendd.Article, function (envelope) {
        var options = {
            url: 'ArticleService.svc/ArticleReviewSubmit',
            data:
            {
                info: envelope.message.data
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Article, new Vendd.Article.Messages.ReviewSuccess(response, envelope.message.data));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Article, new Vendd.Article.Messages.ReviewFailure(response, envelope.message.data));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Article.Messages.ReviewVote, Vendd.Article, function (envelope) {
        var options = {
            url: 'ArticleService.svc/ArticleReviewHelpfullnessVote',
            data:
            {
                info: envelope.message.data.helpfullness
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Article, new Vendd.Article.Messages.ReviewVoteSuccess(response, envelope.message.data.helpfullness.IsPositiveVote));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Article, new Vendd.Article.Messages.ReviewVoteFailure(response, envelope.message.data.helpfullness.IsPositiveVote));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});